import { SvgVariableInput } from './SvgVariableInput';
import { SvgVariableOptions } from './SvgVariableOptions';
import { Svg } from 'ff-canvas';
import { PaintTarget } from '@gift/types/plugins/paintTargets';
import { Json } from '@gift/types/Json';

export function svgToFfCanvas(
    variable: Json.Variable<SvgVariableOptions>,
    input: SvgVariableInput,
    target: PaintTarget
): Svg | Svg[] {

    if (!input.assetUrl) {
        return [];
    }

    return {

        id: variable.id,
        type: 'svg',
        round: true,

        url: input.assetUrl,

        x: variable.x,
        y: variable.y,
        width: variable.width,
        height: variable.height,
        zIndex: variable.zIndex,
        angle: 0,

        scaleX: 1,
        scaleY: 1,
        alpha: input.alpha,

        shadow: input.shadow,
        shadowBlur: input.shadowBlur,
        shadowColor: input.shadowColor,
        shadowOffsetX: input.shadowOffsetX,
        shadowOffsetY: input.shadowOffsetY,

        stroke: input.stroke,
        strokeSize: input.strokeSize,
        strokeStyle: input.strokeStyle,

        custom: {
            watch: [],
            values: {}
        }
    };
}